{
  "helpMessage": "<h3>有保险相关的问题吗？</h3>\n<p>我们的团队乐意为您提供帮助 — 请致电：<br/><a><strong>☎️ {{phone}}</strong></a>（然后按 <strong>Option 2</strong>）<br/>Monday to Friday, 8am–5pm.</p>",
  "insuranceCovered": "您的健康保险会报销部分或全部手术费用吗？",
  "insuranceDetails": "<ul>\n  <li>我将负责保险未涵盖的任何未结金额。</li>\n  <li>我将在入院当天支付所需金额。</li>\n  <li>如果我未能支付账单，我将承担任何催收费用。</li>\n</ul>",
  "insuranceLabel": "我理解并接受以下内容：",
  "insurerLabel": "你的健康保险公司是哪一家？",
  "insurerSelect": {
    "aia": "AIA",
    "nib": "NIB",
    "southern-cross": "Southern Cross"
  },
  "membershipLabel": "会员编号",
  "noCovered": "我将自行承担全部费用。",
  "preApprovalLabel": "您是否已获得此手术的事先批准？",
  "preApprovalText": "<h3>{{insurer}} 预先批准</h3>\n<p>我们将代表您联系 {{insurer}}，请求为您的手术获得批准。</p>\n<p>您将收到结果通知，包括您可能需要支付金额的估算。</p>\n<span>这可能包括：</span>\n<ul>\n<li><strong>自付额：</strong>由您的保单设定的金额，和/或</li>\n<li><strong>差额：</strong>您的保单报销额度与手术费用之间的差额。</li>\n</ul>\n<p>任何自付额或差额都需要在 <strong>手术当天支付</strong>。</p>",
  "title": "健康保险"
}
